import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { events } from '../../util/Events';
import {
  CART_EVENT_UPDATED,
  inSchoolCartService
} from './InSchoolCart/InSchoolCart.service';

const DEFAULT_LEVEL = 'ALL';
const filterIcon = `${themeFolder}/images/filter.svg`;

export class SearchSchoolFilter extends Component {

  constructor(props) {
    super(props);

    this.state = {
      openMobile: false,
      cartSize: inSchoolCartService.get().length,
    };

    events.on(CART_EVENT_UPDATED, () => this._updateCart());
  }

  _updateCart() {
    this.setState({
      cartSize: inSchoolCartService.get().length,
    });
  }

  _toggleControls() {
    this.setState({
      openMobile: !this.state.openMobile,
    });
  }

  _onChangeLevel(e) {
    this._onChangeFilter(e);
  }

  _onChangeFilter(e) {
    this.setState({ openMobile: false });
    this.props.onChangeFilter(e);
  }


  _toggleCart() {
    inSchoolCartService.toggleCart();
  }

  render() {
    const { openMobile } = this.state;
    const { trainings, numResults, locations } = this.props;

    const levels = [...trainings.reduce((t, c) => t.add(c.vak_niveau), new Set())]
      .filter(l => l !== DEFAULT_LEVEL && l !== '');
    const subjects = [...trainings.reduce((t, c) => t.add(c.vak_naam), new Set())];

    const levelItems = levels.map((niveau, key) => {
      return (<option key={key} value={niveau}>{niveau}</option>);
    });

    const subjectsItems = subjects.map((subject, key) => {
      return (<option key={key} value={subject}>{subject}</option>);
    });

    const locationOptions = locations.map((subject, key) => {
      return (<option key={key} value={subject}>{subject}</option>);
    });

    let ctrlCssClass = 'school-page__filter';
    if (openMobile) {
      ctrlCssClass += ' school-page__filter--active';
    }

    const cartBadge = this.state.cartSize;

    return (
      <div className={ctrlCssClass}>
        <div className="school-page__filter-mobile-ctrl">
          <div className="school-page__filter-mobile-cart"
            onClick={() => this._toggleCart()}>
            <i className="fa fa-shopping-cart" aria-hidden="true"></i>
            <div className="school-page__filter-cart-badge tada animated">
              {cartBadge}
            </div>
          </div>
          <div className="school-page__filter-mobile-toggle"
            onClick={() => this._toggleControls()}>
            <img className="school-page__filter-icon" src={filterIcon}/>
                        Filter {numResults} trainingen
          </div>
        </div>
        <div className="container">
          {levelItems.length > 0
                    && <select className="form-control"
                      onChange={e => this._onChangeLevel(e)}
                      name="vak_niveau">
                      <option value="">Selecteer niveau...</option>
                      {levelItems}
                    </select>}
          <select className="form-control"
            onChange={e => this._onChangeFilter(e)}
            name="vak_naam">
            <option value="">Selecteer onderwerp...</option>
            {subjectsItems}
          </select>
          {locationOptions.length >= 2 && <select className="form-control"
            onChange={e => this._onChangeFilter(e)}
            name="loc_naam">
            <option value="">Selecteer locatie...</option>
            {locationOptions}
          </select>}
        </div>
      </div>
    );
  }
}

SearchSchoolFilter.propTypes = {
  trainings: PropTypes.arrayOf(PropTypes.object),
  onChangeFilter: PropTypes.func,
  locations: PropTypes.arrayOf(PropTypes.string),
  numResults: PropTypes.number,
};
